import axios from 'axios'
import { Notification, MessageBox} from 'element-ui' //引入element-ui库
import { getToken } from '@/utils/auth'; // 引入Cookies
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 设置请求的基本URL
  timeout: 50000, // 请求超时时间
//    withCredentials: true, //表示跨域请求时是否需要使用凭证
})
// request拦截器
service.interceptors.request.use(
  config => {
      if (getToken()) {
           config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      } else {
        // config.headers['Authorization'] = `Bearer ${''}`; 
      }
      return config
  },
  error => {
      Promise.reject(error)
  }
)
// 拦截器方式 一
// response 
service.interceptors.response.use(
  response => {
    let showBox = true
    const code = response.status
    if(code === 203 && showBox){
      MessageBox.confirm('登录状态已过期，请重新登录', '系统提示', { confirmButtonText: '重新登录', type: 'warning' }).then(() =>{
          showBox = false
          location.href = '/login';
      })
    }
    return response.data
  },
  error => {
      // 兼容blob下载出错json提示
      if (error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
          const reader = new FileReader()
          reader.readAsText(error.response.data, 'utf-8')
          reader.onload = function () {
              const errorMsg = JSON.parse(reader.result).message
              Notification.error({
                  title: errorMsg,
                  duration: 5000
              })
          }
      } else {
          let code = 0
          try {
              code = error.response.data.status
          } catch (e) {
              if (error.toString().indexOf('Error: timeout') !== -1) {
                  Notification.error({
                      title: '网络请求超时',
                      duration: 5000
                  })
                  return Promise.reject(error)
              }
          }
 
          if (code) {
               if (code === 401) {
                  //  store.dispatch('LogOut').then(() => {
                  //      // 用户登录界面提示
                  //      Cookies.set('point', 401)
                  //      location.reload()
                  // })
               } else if (code === 403) {
                  //  router.push({ path: '/401' })
               } else {
              const errorMsg = error.response.data.message
              if (errorMsg !== undefined) {
                  Notification.error({
                      title: errorMsg,
                      duration: 0
                  })
              }
            }
          } else {
              Notification.error({
                  title: '接口请求失败',
                  duration: 5000
              })
          }
      }
      return Promise.reject(error)
  }
)

export default service; 